import { render, staticRenderFns } from "./contactEdit.vue?vue&type=template&id=7c70fc60&scoped=true&"
import script from "./contactEdit.vue?vue&type=script&lang=js&"
export * from "./contactEdit.vue?vue&type=script&lang=js&"
import style0 from "./contactEdit.vue?vue&type=style&index=0&id=7c70fc60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c70fc60",
  null
  
)

export default component.exports